<template>
  <v-select
    :value="updatedSearchParams"
    :items="Object.values(meterTypes)"
    @input="$emit('update:updatedSearchParams', $event)"
    multiple
    clearable
    hide-details
  >
    <template v-slot:selection="{ item, index }">
      <v-chip v-if="index === 0 || index === 1">
        {{ meterTypeToText(item) }}
      </v-chip>
      <span v-if="index === 2" class="grey--text caption"
        >(+{{ updatedSearchParams.length - 2 }} others)</span
      >
    </template>
    <template v-slot:label>
      <v-icon style="margin-top: -2px">
        {{ "mdi-counter" }}
      </v-icon>
      <span> Taksamittarin tyypit </span>
    </template>
    <template v-slot:item="{ item, attrs, on }">
      <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
        <v-list-item-content>
          <v-list-item-title>
            <v-row no-gutters align="center">
              {{ meterTypeToText(item) }}
            </v-row>
          </v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          <v-checkbox :input-value="active"></v-checkbox>
        </v-list-item-action>
      </v-list-item>
    </template>
  </v-select>
</template>

<script>
import { MeterTypeMixin } from "@/models/MeterTypes";
export default {
    props: {
        updatedSearchParams: Array
    },
    emits: ["update:updatedSearchParams"],
    mixins: [MeterTypeMixin]
};
</script>
